// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2cJQW","header":"PatientBlock_header__19RF0","label":"PatientBlock_label__2_faM","option":"PatientBlock_option__2dOID"};